import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import ability from '@/plugins/ability'
import Auth from '@/services/Auth'
import Attributes from '@/services/Attributes'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: {
      user: null,
      checked: false
    },
    alert: {
      visible: false,
      text: '',
      color: 'success'
    },
    attributes: {
      loading: false,
      data: []
    }
  },
  mutations: {
    ALERT(state, { visible, text, color }) {
      state.alert.visible = visible
      state.alert.text = text
      state.alert.color = color
    },
    LOGIN(state, user) {
      state.auth.user = user
    },
    LOGIN_CHECKED(state) {
      state.auth.checked = true
    },
    LOGOUT(state) {
      state.auth.user = null
    },
    UPDATE_ATTRIBUTES(state, attributes) {
      state.attributes.data = attributes
    }
  },
  actions: {
    alert({ commit }, { visible, text, color }) {
      commit('ALERT', {
        visible: visible === undefined ? true : visible,
        text: text || '',
        color: color || undefined
      })
    },
    async login({ commit, dispatch }, { email, password }) {
      const result = await Auth.login(email, password)

      commit('LOGIN', result.user)

      ability.update(result.user.permission_rules)

      dispatch('getAttributes')
    },
    logout({ commit }) {
      Auth.logout()

      commit('LOGOUT')
    },
    setLoggedOut({ commit }) {
      commit('LOGOUT')
    },
    async getUser({ commit, dispatch }) {
      try {
        const user = await Auth.me()

        commit('LOGIN', user)

        ability.update(user.permission_rules)

        dispatch('getAttributes')
      } catch (e) {
        if (e.response.status === 401 && router.currentRoute.name !== 'login') {
          router.push({ name: 'login' })
          return
        }

        if (router.currentRoute.name === 'login') return

        throw e
      } finally {
        commit('LOGIN_CHECKED')
      }
    },
    async getAttributes({ commit }) {
      const attributes = await Attributes.fetch()

      commit('UPDATE_ATTRIBUTES', attributes)
    }
  }
})
